import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import React from 'react';
import kcisRoutes from './routes_kcis/';
import kipsRoutes from './routes_kips/';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from 'react-redux';
import { configureStore } from "./redux/store";
import CheckVersion from "./component/CheckVersion";
import store from "./services/store";

var erp_type='kcis';
if(localStorage.getItem("erp_type")){
  if(localStorage.getItem("erp_type")=='kips'){
      erp_type='kips';
  }
  else{
      erp_type='kcis';
  }
}
else{
      erp_type='kcis';
}

const App = ({ children, initialState = {} }) => (
    <Provider store={store(initialState)}>
    {children}
		<CheckVersion/>
        <Router basename="/">
             {erp_type=='kips' ? (
               <Switch>
                   {kipsRoutes.map((prop, key) => {
                           return <Route path={prop.path} key={key} component={prop.component} />;
                   })}
               </Switch>
              ) : (
                <Switch>
                    {kcisRoutes.map((prop, key) => {
                            return <Route path={prop.path} key={key} component={prop.component} />;
                    })}
                </Switch>
             )}
        </Router>
    </Provider>
);

export default App;
